import { SUCCESS_RESPONSE_TYPE } from 'api/constants'
import { UseQueryOptions, useQuery } from 'react-query'
import { useCurrentWorkspaceId } from 'hooks/useCurrentWorkspaceId'
import { ConnectableAccount, IntegrationAuthsClient } from 'api/clients/IntegrationAuthsClient'

interface Data {
  data: ConnectableAccount[]
  metadata: any
}

export const fetchConnectableAccounts = async (id: number, workspaceId: number) => {
  const res = await IntegrationAuthsClient.connectableAccounts({ integrationAuthId: id, workspaceId })

  if (res.type !== SUCCESS_RESPONSE_TYPE) {
    throw new Error()
  }

  return res.data
}

export const useConnectableAccounts = (id?: number, options?: UseQueryOptions<Data>) => {
  const workspaceId = useCurrentWorkspaceId()

  return useQuery<Data>(
    ['workspaces', workspaceId, 'integrationAuths', id, 'connectableAccounts'],
    () => {
      if (!id) return Promise.resolve({ data: [], metadata: {} })
      return fetchConnectableAccounts(id, workspaceId)
    },
    {
      refetchOnWindowFocus: false,
      staleTime: (options?.cacheTime || 0) * 0.5,
      enabled: !!id,
      ...options,
    },
  )
}
